module.exports = __webpack_public_path__ + "static/media/buseireann.cff81020.png";